module.exports = __webpack_public_path__ + "img/facial_hair_mustache_thin.bfc255de.png";